import { EventListener } from "@/utils/common";
export const emitter = new EventListener({
    uploadFile: [],
    uploadSuccessFile: [],
    uploadFailFile: [],
});